import { call, takeLatest, put } from 'redux-saga/effects';
import getAPI from 'core/api/iv-back';

import { YieldOf } from 'types/utils';
import { sagaWithCallback } from 'core/store/utils';
import { logout } from '../api-auth/actions';

import { fetchKeywords } from './actions';

export function* fetchKeywordsSaga() {
  const { getKeywords } = getAPI();
  const response: YieldOf<typeof getKeywords> = yield call(getKeywords);
  const { data = [], ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    return data;
  } else {
    throw new Error('fetch keywords failed: ' + problem);
  }
}

export default function* saga() {
  yield takeLatest(fetchKeywords.type, sagaWithCallback(fetchKeywordsSaga));
}
